// https://github.com/awerlang/angular-responsive-tables

'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function responsiveTable() {
	'ngInject';

	return {
		restrict: 'A',
		compile: function compile(element, attrs) {
			attrs.$addClass('responsive');
			var headers = element[0].querySelectorAll('tr > th');
			if (headers.length) {
				var rows = element[0].querySelectorAll('tbody > tr');
				Array.prototype.forEach.call(rows, function (row) {
					var headerIndex = 0;
					Array.prototype.forEach.call(row.querySelectorAll('td'), function (value) {
						var th = value.parentElement.querySelector('th') || headers.item(headerIndex);
						var title = th.textContent;
						if (title && !value.getAttributeNode('data-title')) {
							value.setAttribute('data-title', title);
						}
						var colspan = value.getAttributeNode('colspan');
						headerIndex += colspan ? parseInt(colspan.value, 10) : 1;
					});
				});
			}
		}
	};
}

exports['default'] = responsiveTable;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/responsive-table/responsive-table.directive.js
 **/